import Swiper, { Navigation, Manipulation } from 'swiper';

const blockNavChange = (slider, block) => {
	slider.on('update', () => {
		if (slider.slides.length <= 1) {
			block.classList.remove('active');
		} else {
			block.classList.add('active');
		}
	});
};

const blockAddSlide = (slider, index, img) => {
	let newNumber = 0;

	slider.slides.every((slide, number) => {
		const { project } = slide.dataset;

		if (project > index) {
			newNumber = number;
			return false;
		}

		if (project < index) {
			newNumber = number + 1;
		}

		return true;
	});

	slider.addSlide(
		newNumber,
		`<img class="swiper-slide" src="${img}" data-project="${index}" alt="Project - ${index}">`,
	);
	slider.update();

	return newNumber;
};

const blockRemoveSlide = (slider, index) => {
	slider.slides.forEach((v, k) => {
		if (parseInt(v.dataset.project, 10) === index) {
			slider.removeSlide(k);
		}
	});
	return false;
};

const blockNavCounter = (slider, index) => {
	const counter = document.querySelector('[data-floor-index]');
	const floor = slider.slides[index];

	if (counter && floor) counter.dataset.floorIndex = floor.dataset.project;
};

const blockAboutIntro = () => {
	const block = '.js-swiper-apartaments';
	const blockContainer = document.querySelector(block);
	if (!blockContainer) return false;

	const swiperParams = {
		modules: [Navigation, Manipulation],
		pagination: false,
		navigation: {
			nextEl: '.b-apartaments-floors__next',
			prevEl: '.b-apartaments-floors__prev',
		},
		autoplay: false,
		slidesPerView: 1,
		spaceBetween: 0,
		disableOnInteraction: false,
		resizeObserver: true,
		observer: true,
		observeParents: true,
		loop: false,
		on: {
			afterInit: (event) => {
				blockNavChange(event, blockContainer.previousElementSibling);
			},
			observerUpdate: (event) => {
				blockNavCounter(event, event.realIndex);
			},
			realIndexChange: (event) => {
				blockNavCounter(event, event.realIndex);
			},
		},
	};

	const slider = new Swiper(block, swiperParams);

	return slider;
};

const swiper = blockAboutIntro();
const floors = document.querySelectorAll('[data-floor-number]');
const floorZero = document.querySelector('[data-floor-number="all"]');
const projectZero = document.querySelector('[data-project="all"]');

const changeClass = (items, className, type) => {
	items.forEach((item) => {
		if (!item) return;
		if (type === 'add') {
			item.classList.add(className);
		} else if (type === 'remove') {
			item.classList.remove(className);
		} else {
			item.classList.toggle(className);
		}
	});
};
// TODO refactoring
floors.forEach((el) => {
	const floor = el;
	let done = true;
	let realIndex;
	floor.onclick = (e) => {
		const floorBtn = e.target;
		const { floorNumber, floorImg } = e.target.dataset;

		if (floorNumber === 'all') {
			changeClass(floors, 'active', 'remove');
			changeClass([floorZero, projectZero], 'active', 'add');

			if (!swiper) return;
			Object.keys(swiper.slides).forEach((v) => {
				swiper.removeSlide(v);
			});
			swiper.update();
			return;
		}

		if (swiper) {
			if (floorBtn.classList.contains('active')) {
				done = blockRemoveSlide(swiper, parseInt(floorNumber, 10));
			} else {
				realIndex = blockAddSlide(swiper, parseInt(floorNumber, 10), floorImg);
			}
		}

		changeClass([floorBtn], 'active', 'toogle');

		const active = document.querySelector('.active[data-floor-number]');

		if (active) {
			changeClass([floorZero, projectZero], 'active', 'remove');
		} else {
			changeClass([floorZero, projectZero], 'active', 'add');
		}

		if (!swiper) return;
		swiper.update();

		if (done) {
			swiper.slideTo(parseInt(realIndex, 10));
		} else {
			swiper.slideTo(0);
		}
	};
});
